var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogOut02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "log-out-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.99904 17.0001L2.99905 12.0001M2.99905 12.0001L7.99904 7.0001M2.99905 12.0001H14.999M11.999 17.0001C11.999 17.9301 12 18.5 12 19C12 20 12 21 12 21C12 21 15.0691 21.0001 15.999 21.0001H16.499C17.8969 21.0001 18.4987 21 18.9987 21C19.9987 21 20 21 20.9986 21.0001C21 20.5 20.999 17.8979 20.999 16.5001V7.5001C20.999 6.10228 20.9982 5.5 20.9982 5C20.9981 4 21 3.00001 21 3.00001C20.5 2.99997 17.8969 3.0001 16.499 3.0001H15.999C15.0691 3.0001 12.5 3.0001 12 3.0001C12 4 12 3.78958 12 5C12 5.5 11.999 6.07013 11.999 7.0001",
    stroke: "#DD1C22",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut02);
export default __webpack_public_path__ + "static/media/log-out-02.f3d95786bf71428c041f93bb0a56632a.svg";
export { ForwardRef as ReactComponent };